import Navbar from "@/components/site/Navbar";
import Hero from "@/components/site/Hero";
import Marquee from "@/components/site/Marquee";
import Manifesto from "@/components/site/Manifesto";
import Services from "@/components/site/Services";
import Gallery from "@/components/site/Gallery";
import Testimonials from "@/components/site/Testimonials";
import QuoteForm from "@/components/site/QuoteForm";
import MapSection from "@/components/site/MapSection";
import Footer from "@/components/site/Footer";
import WhatsAppFloat from "@/components/site/WhatsAppFloat";

export default function Landing() {
  return (
    <div className="bg-bone text-[#1A1A1A]" data-testid="landing-page">
      <div className="grain" aria-hidden="true" />
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <Manifesto />
        <Services />
        <Gallery />
        <Testimonials />
        <QuoteForm />
        <MapSection />
      </main>
      <Footer />
      <WhatsAppFloat />
    </div>
  );
}
